module.exports = [{"id":0,"name":"小C","text":"伏魔传伏魔传伏魔传伏魔传伏魔传伏魔传伏魔传伏魔传","isAward":true},{"id":1,"name":"小D","text":"超酷超好玩","isAward":false},{"id":2,"name":"小E","text":"EEEEEE","isAward":false},{"id":3,"name":"小F","text":"超酷超好玩","isAward":true},{"id":4,"name":"小R","text":"222","isAward":false}]


//////////////////
// WEBPACK FOOTER
// ./src/api/barrage.json
// module id = PuGu
// module chunks = 1